module.exports = __webpack_public_path__ + "static/media/bg.1ad17ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/yysChargingOperator/index/images/bg.png
// module id = 1231
// module chunks = 0